import {
  WEEKDAYS_SHORT, calendarOf, sameDay, dateKey, monthWeeks, formatTime, startOfDay, addDays,
} from '../../lib/calendar';

const MAX_VISIBLE = 3;

// Ay görünümü: 7 sütunlu ızgara; günde en fazla 3 etkinlik, fazlası "+N daha"
export const MonthGrid = ({ cursor, events, holidays, onDayClick, onSlotClick, onEventClick, selectedId }) => {
  const weeks = monthWeeks(cursor);
  const today = new Date();

  const eventsOnDay = (day) => {
    const start = startOfDay(day).getTime();
    const end = addDays(day, 1).getTime();
    return events
      .filter((e) => e.end.getTime() > start && e.start.getTime() < end)
      .sort((a, b) => Number(b.all_day) - Number(a.all_day) || a.start - b.start);
  };

  return (
    <div className="flex-1 min-h-0 flex flex-col" data-testid="month-grid">
      <div className="grid grid-cols-7 border-b border-border shrink-0">
        {WEEKDAYS_SHORT.map((d) => <div key={d} className="py-2 text-center text-xs font-medium text-muted-foreground">{d}</div>)}
      </div>
      <div className="flex-1 min-h-0 grid overflow-y-auto" style={{ gridTemplateRows: `repeat(${weeks.length}, minmax(96px, 1fr))` }}>
        {weeks.map((week) => (
          <div key={dateKey(week[0])} className="grid grid-cols-7">
            {week.map((day) => {
              const inMonth = day.getMonth() === cursor.getMonth();
              const dayEvents = eventsOnDay(day);
              const holiday = holidays?.[dateKey(day)];
              return (
                <div
                  key={dateKey(day)}
                  className={`border-b border-l border-border p-1 min-w-0 cursor-pointer hover:bg-secondary/40 ${inMonth ? '' : 'bg-secondary/30'}`}
                  onClick={() => onSlotClick(new Date(day.getFullYear(), day.getMonth(), day.getDate(), 9, 0))}
                  data-testid={`month-cell-${dateKey(day)}`}
                >
                  <button
                    onClick={(e) => { e.stopPropagation(); onDayClick(day); }}
                    className={`h-6 min-w-6 px-1 rounded-full text-xs font-medium flex items-center justify-center ${
                      sameDay(day, today) ? 'bg-primary text-primary-foreground' : inMonth ? '' : 'text-muted-foreground'
                    }`}
                    aria-label={`${day.getDate()} ${day.toLocaleDateString('tr-TR', { month: 'long' })} günlük görünüm`}
                  >
                    {day.getDate()}
                  </button>
                  <div className="mt-0.5 space-y-0.5">
                    {holiday && <div className="truncate rounded px-1 text-[10px] bg-secondary text-muted-foreground" title={holiday}>{holiday}</div>}
                    {dayEvents.slice(0, MAX_VISIBLE).map((e) => (
                      <button
                        key={e.id}
                        onClick={(ev) => { ev.stopPropagation(); onEventClick(e); }}
                        className={`w-full truncate rounded px-1 text-left text-[11px] leading-5 ${
                          e.all_day ? `border-l-[3px] font-medium ${calendarOf(e.color).box}` : 'hover:bg-secondary'
                        } ${selectedId === e.id ? 'ring-2 ring-primary' : ''}`}
                        title={e.title}
                        data-testid={`event-${e.id}`}
                      >
                        {!e.all_day && <span className={`inline-block h-1.5 w-1.5 rounded-full mr-1 align-middle ${calendarOf(e.color).dot}`} />}
                        {!e.all_day && <span className="text-muted-foreground mr-1">{formatTime(e.start)}</span>}
                        {e.title}
                      </button>
                    ))}
                    {dayEvents.length > MAX_VISIBLE && (
                      <button onClick={(ev) => { ev.stopPropagation(); onDayClick(day); }} className="px-1 text-[11px] text-primary hover:underline">
                        +{dayEvents.length - MAX_VISIBLE} daha
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthGrid;
